import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { Box, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { UploadedPdfRow } from '~/components/UploadedPdfRow/UploadedPdfRow';
import { useFilePicker } from '~/hooks/useFilePicker';
import { usePreviewCustomPagePdf } from '~/hooks/usePreviewCustomPagePdf';
import { useUploadCustomPagePdf } from '~/hooks/useUploadCustomPagePdf';
import { useLocaleKeys } from '~/i18n';
import s from './PdfPageContent.module.scss';
export const GetPdfPageContentTID = (parentTestId)=>getTestIds(parentTestId);
export const PdfPageContent = (param)=>{
    let { pdfName, pdfFileName, fileSizeBytes, onFileChange, disabled, submitAttempted, testId } = param;
    var _ref, _ref1, _ref2;
    const { t } = useLocaleKeys();
    const testIds = useMemo(()=>GetPdfPageContentTID(testId), [
        testId
    ]);
    const [uploadedFile, setUploadedFile] = useState(undefined);
    const currentPdfName = (_ref = uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.pdfName) !== null && _ref !== void 0 ? _ref : pdfName;
    const currentPdfFileName = (_ref1 = uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.pdfFileName) !== null && _ref1 !== void 0 ? _ref1 : pdfFileName;
    const currentFileSizeBytes = (_ref2 = uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.fileSizeBytes) !== null && _ref2 !== void 0 ? _ref2 : fileSizeBytes;
    const isEmpty = currentPdfName == null;
    const showError = !disabled && isEmpty && !!submitAttempted;
    const handleUploadSuccess = useCallback((fileInfo)=>{
        setUploadedFile(fileInfo);
        onFileChange(fileInfo);
    }, [
        onFileChange
    ]);
    const { handleFileSelected, isUploading } = useUploadCustomPagePdf({
        onSuccess: handleUploadSuccess,
        fileSizeErrorTestId: testIds.PdfPageContentTestIds.FileSizeErrorToast(),
        uploadErrorTestId: testIds.PdfPageContentTestIds.UploadErrorToast()
    });
    const { openFilePicker, fileInputElement } = useFilePicker({
        accept: '.pdf',
        onFileSelected: handleFileSelected,
        testId: testIds.PdfPageContentTestIds.FileInput()
    });
    const { openPreview } = usePreviewCustomPagePdf({
        biName: 'pdf_page_content_preview_modal',
        testId: testIds.PdfPageContentTestIds.PdfViewerModal()
    });
    const handlePreview = useCallback(()=>{
        if (currentPdfName == null || currentPdfFileName == null) return;
        openPreview(currentPdfName, currentPdfFileName);
    }, [
        currentPdfName,
        currentPdfFileName,
        openPreview
    ]);
    const hasFile = !isEmpty || isUploading;
    if (disabled) {
        if (isEmpty) return /*#__PURE__*/ _jsx(Box, {
            testId: testIds.PdfPageContentTestIds.Root()
        });
        return /*#__PURE__*/ _jsx(Box, {
            testId: testIds.PdfPageContentTestIds.Root(),
            children: /*#__PURE__*/ _jsx(UploadedPdfRow, {
                testId: testIds.PdfPageContentTestIds.UploadedPdfRow(),
                pdfFileName: currentPdfFileName !== null && currentPdfFileName !== void 0 ? currentPdfFileName : '',
                fileSizeBytes: currentFileSizeBytes,
                onPreview: handlePreview
            })
        });
    }
    return /*#__PURE__*/ _jsxs(Box, {
        testId: testIds.PdfPageContentTestIds.Root(),
        children: [
            fileInputElement,
            hasFile ? /*#__PURE__*/ _jsx(UploadedPdfRow, {
                testId: testIds.PdfPageContentTestIds.UploadedPdfRow(),
                pdfFileName: currentPdfFileName !== null && currentPdfFileName !== void 0 ? currentPdfFileName : '',
                fileSizeBytes: currentFileSizeBytes,
                onChangeFile: openFilePicker,
                onPreview: handlePreview,
                isUploading: isUploading
            }) : /*#__PURE__*/ _jsxs(Box, {
                testId: testIds.PdfPageContentTestIds.UploadArea(),
                className: "".concat(s.uploadArea).concat(showError ? " ".concat(s.hasError) : ''),
                onClick: openFilePicker,
                children: [
                    showError && /*#__PURE__*/ _jsx(Box, {
                        testId: testIds.PdfPageContentTestIds.UploadAreaError()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        children: t.customPages.pdfUpload.dragOrClick()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        children: t.customPages.pdfUpload.sizeLimit()
                    })
                ]
            })
        ]
    });
};
